export enum FullSizeWindowOverlayColorOpacity {
    Strong = 0.7,
    Faint = 0.2,
}
